import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { map, Observable } from 'rxjs';
import { Item } from '../select-field/select-field.component';

interface TipologicaValue {
  id: number | string;
  nome: string;
}

@Injectable({
  providedIn: 'root',
})
export class TipologicheService {
  private readonly baseUrl = environment.baseUrl;
  private httpClient = inject(HttpClient);

  fetchGetAllTipologicaItem(
    tipologica: string,
    withFindAll?: boolean
  ): Observable<never[]> {
    const v2Tipologies = [
      'luoghi_erogazione_prestazione',
      'tipo_evento_calendario',
    ];
    const apiVersion = v2Tipologies.includes(tipologica) ? 'v2' : 'v1';
    const reqUrl = withFindAll
      ? `${this.baseUrl}${apiVersion}/tipology/findAll/${tipologica}`
      : `${this.baseUrl}${apiVersion}/${tipologica}`;
    return this.httpClient.get<never[]>(reqUrl);
  }

  /**
   * Fetches all the values of a tipologica mapped as select items.
   * @returns {Observable<Item[]>} the tipologica values as items
   */
  fetchTipologicaItems(tipologica: string): Observable<Item[]> {
    return (
      this.fetchGetAllTipologicaItem(tipologica, true) as Observable<
        TipologicaValue[]
      >
    ).pipe(map(values => values.map(({ id, nome }) => ({ id, name: nome }))));
  }
}
